var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"c-btn",class:{
          'c-btn_secondary': _vm.color === 'secondary',
          'c-btn_tertiary': _vm.color === 'tertiary',
        },attrs:{"color":_vm.color,"small":!_vm.mobile && !_vm.isMobile,"disabled":_vm.disabled,"loading":_vm.loading,"to":_vm.to,"href":_vm.href,"target":_vm.target,"width":_vm.width,"elevation":"0"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }